import { render, staticRenderFns } from "./V2Banner.vue?vue&type=template&id=2d4e52db&scoped=true"
import script from "./V2Banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./V2Banner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./V2Banner.vue?vue&type=style&index=0&id=2d4e52db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e52db",
  null
  
)

export default component.exports